import { STATUS_LABEL } from "@/lib/format";

export function StatusBadge({ status, label, testId }) {
  const s = status || "pending";
  return (
    <span data-testid={testId} data-status={s} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap status-${s}`}>
      <span className={`h-1.5 w-1.5 rounded-full dot-${s}`} />
      {label || STATUS_LABEL[s]}
    </span>
  );
}

export function StatusDot({ status, className = "" }) {
  return <span className={`inline-block h-2.5 w-2.5 rounded-full dot-${status || "pending"} ${className}`} />;
}
